<template lang="pug">
    section
        Address.main(
            v-for="(address, index) in addresses" :key="index"
            :index="index"
            :data="address"
            :show-default-switches="addresses > 1"
        )
        //- el-button(disabled type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addAddress") {{ $t('Add Address') }}
</template>

<i18n>
{
  "de": {
    "Add Address": "Addresse hinzufügen"
  }
}
</i18n>

<script>

import { mapGetters } from 'vuex'

import Address from './Partials/Address'

export default {
    name: 'AccountAddresses',
    components: {
        Address,
    },
    computed: {
        ...mapGetters({
            addresses: 'account/form_addresses'
        })
    },
    methods: {
        addAddress() {
            // TODO
        }
    }
}
</script>

<style lang="sass" scoped></style>
